
export const GET_TASKERS = 'GET_TASKERS';
export const GET_TASKERS_ERR = 'GET_TASKERS_ERR';
export const GET_TASKER = 'GET_TASKER';
export const GET_TASKER_ERR = 'GET_TASKER_ERR';

export const UPDATE_ONBOARD_STATUS = 'UPDATE_ONBOARD_STATUS';
export const UPDATE_ONBOARD_STATUS_ERR = 'UPDATE_ONBOARD_STATUS_ERR';